// import React from "react";

const UnauthorizedAccess = () => {
    return (
        <>
        <h1>Access Denied (401) - Authentication Required</h1>
        <p>Sorry, but you don't have permission to view this page. Please make sure you are logged in or 
            have the necessary credentials to access this content. If you believe this is in error, please 
            contact our support team for assistance.
        </p>
        </>
    )
}

export default UnauthorizedAccess;